import React from 'react';
import { StyledRightSidePanel } from './styles';
import { SidePanelProps } from './helpers';
import { Icon } from '../../Universal/NovusDSImports';

const RightSidePanel: React.FC<SidePanelProps> = ({
  header,
  onClose,
  body,
  fetchMessagesStyles
}) => {
  const closeRightSidePanel = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <StyledRightSidePanel
      id="right-panel"
      fetchMessagesStyles={fetchMessagesStyles}
      data-testid="right-side-panel"
    >
      <div className="panel-header" data-testid="right-side-panel-header">
        <h1>{header}</h1>

        <span
          role="button"
          tabIndex={0}
          aria-label="Close right side panel"
          onClick={closeRightSidePanel}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              closeRightSidePanel();
            }
          }}
          className="close-icon"
          data-testid="close-right-side-panel-button"
        >
          <Icon
            icon="close"
            stroke="white"
            width="20px"
            height="20px"
            aria-hidden="true"
            focusable="false"
          />
        </span>
      </div>
      <div className="panel-body">{body}</div>
    </StyledRightSidePanel>
  );
};

export default RightSidePanel;
